/* Decorate Square's native page; never maintain a second saved-products store. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  if (!location.pathname.endsWith('/apps/page/wishlist')) return;
  const heart = '<svg class="tf-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  const cards = new Map();
  let recommendations = document.querySelector('.tf-wishlist-recommendations'), recommendationsRequest = Boolean(recommendations), frame;
  const productCards = page => [...page.querySelectorAll('.Vtl-WishlistProduct')];
  const feedback = (page, message) => {
    let status = page.querySelector('.tf-wishlist-feedback');
    if (!status) { status = document.createElement('p'); status.className = 'tf-wishlist-feedback'; status.setAttribute('role', 'status'); page.append(status); }
    if (status.textContent !== message) status.textContent = message;
  };
  async function cardMarkup(path) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin || !url.pathname.startsWith(root + 'products/')) throw new Error('Invalid product URL');
    url.search = '?view=tf-wishlist-card';
    if (!cards.has(url.pathname)) cards.set(url.pathname, fetch(url, {credentials:'same-origin'}).then(async response => {
      if (!response.ok) throw new Error('Product unavailable');
      const html = await response.text();
      const content = new DOMParser().parseFromString(html, 'text/html');
      if (!content.querySelector('[data-tf-card]')) throw new Error('Product card unavailable');
      return content.body.innerHTML;
    }).catch(error => { cards.delete(url.pathname); throw error; }));
    return cards.get(url.pathname);
  }
  async function hydrate(card) {
    if (card.dataset.tfWishlistLoading || card.dataset.tfWishlistReady) return;
    const link = card.querySelector('.Vtl-WishlistProduct__Link');
    if (!link) return;
    card.dataset.tfWishlistLoading = 'true';
    try {
      const html = await cardMarkup(link.getAttribute('href'));
      if (!card.isConnected) return;
      const wrapper = document.createElement('div'); wrapper.className = 'tf-wishlist-card'; wrapper.innerHTML = html;
      // Keep the saved variant selected when it is still available.
      const variantId = new URL(link.href).searchParams.get('variant');
      const select = wrapper.querySelector('select[name="id"]');
      if (select && [...select.options].some(option => option.value === variantId && !option.disabled)) select.value = variantId;
      const radio = [...wrapper.querySelectorAll('input[type="radio"][name="id"]')].find(input => input.value === variantId && !input.disabled);
      if (radio) radio.checked = true;
      const variant = radio || select;
      card.append(wrapper); card.dataset.tfWishlistReady = 'true';
      if (variant) variant.dispatchEvent(new Event('change', {bubbles:true}));
      const wish = wrapper.querySelector('[data-tf-wish]');
      if (wish) { wish.setAttribute('aria-pressed', 'true'); wish.classList.add('tf-wish-saved'); wish.setAttribute('aria-label', card.querySelector('.Vtl-WishlistProduct__CloseButton')?.getAttribute('aria-label') || 'Remove from wishlist'); }
    } catch { /* Keep the original working provider card on any rendering failure. */ }
    finally { delete card.dataset.tfWishlistLoading; }
  }
  async function loadRecommendations(page) {
    if (recommendationsRequest) return;
    recommendationsRequest = true;
    try {
      const response = await fetch(root + 'search?view=tf-wishlist-recommendations', {credentials:'same-origin'});
      if (!response.ok) throw new Error('Recommendations unavailable');
      const content = new DOMParser().parseFromString(await response.text(), 'text/html');
      const section = content.querySelector('.tf-wishlist-recommendations');
      if (!section || !section.querySelector('[data-tf-card]')) return;
      recommendations = section; page.closest('.vtl-proxy-page-wishlist').after(section);
      recommendations.hidden = !page.querySelector('.Vtl-WishlistPage__EmptyList');
    } catch { /* An empty wishlist remains usable without recommendations. */ }
  }
  function decorate() {
    const page = document.querySelector('.Vtl-WishlistPage'); if (!page) return;
    const title = page.querySelector('.Vtl-WishlistPage__Title');
    if (!title) return;
    if (title && !title.dataset.tfTitle) { title.innerHTML = 'Your Wishlist <em>Products</em>'; title.dataset.tfTitle = 'true'; }
    const empty = page.querySelector('.Vtl-WishlistPage__EmptyList');
    const isEmpty = Boolean(empty);
    if (page.classList.contains('tf-wishlist-empty') !== isEmpty) page.classList.toggle('tf-wishlist-empty', isEmpty);
    let toolbar = page.querySelector('.tf-wishlist-toolbar');
    if (!toolbar) {
      toolbar = document.createElement('div'); toolbar.className = 'tf-wishlist-toolbar';
      toolbar.innerHTML = '<span class="tf-wishlist-count" aria-live="polite"></span><button type="button" class="tf-wishlist-share"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m9 10 6-4M9 14l6 4"/></svg>Share List</button><button type="button" class="tf-wishlist-clear">Clear All</button>';
      (page.querySelector('.Vtl-WishlistPage__Description') || title).after(toolbar);
    }
    const count = productCards(page).length;
    const label = count + (count === 1 ? ' item saved' : ' items saved');
    const counter = toolbar.querySelector('.tf-wishlist-count'); if (counter.textContent !== label) counter.textContent = label;
    const share = toolbar.querySelector('.tf-wishlist-share'); share.disabled = !page.querySelector('.Vtl-WishlistPage__ShareAction[aria-label="Copy link"]');
    if (empty && !empty.querySelector('.tf-wishlist-start')) {
      const icon = document.createElement('div'); icon.className = 'tf-wishlist-empty-icon'; icon.innerHTML = heart; empty.prepend(icon);
      const message = empty.querySelector('.Vtl-WishlistPage__EmptyMessage'); if (message) message.textContent = 'Your wishlist is empty';
      const copy = document.createElement('p'); copy.className = 'tf-wishlist-empty-copy'; copy.textContent = "Save the products you love by tapping the heart icon, and they’ll show up here so you can find them again easily.";
      const start = document.createElement('a'); start.className = 'tf-wishlist-start'; start.href = root + 'collections/all'; start.textContent = 'Start Shopping'; empty.append(copy, start);
    }
    productCards(page).forEach(hydrate);
    if (recommendations && recommendations.hidden === isEmpty) recommendations.hidden = !isEmpty;
    if (isEmpty) loadRecommendations(page);
  }
  document.addEventListener('click', async event => {
    const page = event.target.closest('.Vtl-WishlistPage'); if (!page) return;
    if (event.target.closest('.tf-wishlist-share')) {
      page.querySelector('.Vtl-WishlistPage__ShareAction[aria-label="Copy link"]')?.click();
    }
    const clear = event.target.closest('.tf-wishlist-clear');
    if (clear) {
      clear.disabled = true;
      try {
        for (const card of productCards(page)) {
          if (!card.isConnected) continue;
          await new Promise((resolve, reject) => {
            const watcher = new MutationObserver(() => { if (!card.isConnected) { watcher.disconnect(); clearTimeout(timeout); resolve(); } });
            const timeout = setTimeout(() => { watcher.disconnect(); reject(new Error('Unable to clear the list. Please try again.')); }, 8000);
            watcher.observe(page, {childList:true,subtree:true}); card.querySelector('.Vtl-WishlistProduct__CloseButton')?.click();
          });
        }
        feedback(page, 'Wishlist cleared.');
      } catch (error) { feedback(page, error.message); }
      finally { clear.disabled = false; }
    }
  });
  new MutationObserver(() => { cancelAnimationFrame(frame); frame = requestAnimationFrame(decorate); }).observe(document.querySelector('#MainContent') || document.body, {childList:true,subtree:true});
  decorate();
})();
